export default __webpack_public_path__ + "static/media/resource.482e2e13.svg";